import { useCallback } from 'react';
import { TaskCategory } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import {
  CategoryPhone,
  ClientEmail,
  DataAnalysis,
  Database,
  InvoiceCollection,
  Other,
  Outreach,
  Report,
  Research,
  VendorCall,
  VendorEmail,
} from '@sib/ui/icons';

export const useTranslateCategory = () => {
  const { t } = useTranslation();

  return useCallback(
    (category: string) => t(`enums.categories.${category.replace(' ', '_')}`),
    [t]
  );
};

export const categoryIconMap = {
  [TaskCategory.ClientCall]: CategoryPhone,
  [TaskCategory.ClientEmail]: ClientEmail,
  [TaskCategory.DataAnalysis]: DataAnalysis,
  [TaskCategory.DataGathering]: Database,
  [TaskCategory.InternalOutreach]: Outreach,
  [TaskCategory.Other]: Other,
  [TaskCategory.ReportBuild]: Report,
  [TaskCategory.VendorCall]: VendorCall,
  [TaskCategory.VendorEmail]: VendorEmail,
  [TaskCategory.InvoiceCollection]: InvoiceCollection,
  [TaskCategory.Research]: Research,
} as const;
